export default __webpack_public_path__ + "static/media/logo512.5e7f8ec4.png";